import { useState } from 'react'
import { generateShopSSOToken } from '@/lib/pocketbase'

interface ShopPromoBannerProps {
  onDismiss: () => void
}

const ShopPromoBanner = ({ onDismiss }: ShopPromoBannerProps) => {
  const [isLoadingSSO, setIsLoadingSSO] = useState(false)

  const handleGoToShop = async () => {
    try {
      setIsLoadingSSO(true)
      const redirectUrl = await generateShopSSOToken()
      window.open(redirectUrl, '_blank')
    } catch (error) {
      console.error('Failed to redirect to shop:', error)
    } finally {
      setIsLoadingSSO(false)
    }
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[51] bg-secondary text-white py-2 px-4">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 flex-1">
          <span className="text-lg">🎉</span>
          <p className="text-sm font-medium">
            You've earned points! Visit the Shop to redeem them.
            <span className="hidden sm:inline"> (1 booq point = 8 oinks)</span>
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={handleGoToShop}
            disabled={isLoadingSSO}
            className="bg-white text-secondary font-semibold text-sm px-3 py-1 rounded hover:bg-opacity-90 transition-colors disabled:opacity-50"
          >
            {isLoadingSSO ? 'Loading...' : 'Go to Shop'}
          </button>
          <button
            onClick={onDismiss}
            className="text-white hover:text-white/80 transition-colors p-1"
            aria-label="Dismiss banner"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ShopPromoBanner
